import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { widgetsAtom } from '@/store/tasksApprovals/widgets'
import { IApproval, IApprovalDetail, ICompliance, ITaskDetail } from '@/types/tasksApprovals'

const Container = ({
    item,
    itemDetails,
    onClose,
}: {
    item: IApproval | ICompliance
    itemDetails: ITaskDetail | IApprovalDetail
    onClose: () => void
}) => {
    const { t } = useTranslation()
    const [widgets] = useAtom(widgetsAtom)
    const systemID = item.system_id
    const systemName = widgets.filter((i) => i.id === systemID)[0]?.system_name
    const _link = itemDetails?.approval_link ?? itemDetails?.action_source_system_parent_url

    const onApprove = () => {
        window.open(_link)
    }

    return (
        <Box>
            <Box display="flex" justifyContent="flex-start">
                <Button variant="secondary" mr="16px" onClick={onClose}>
                    {t('tasksApprovals.drawer.buttons.close')}
                </Button>

                {_link && (
                    <Button variant="primary" letterSpacing="1.5px" textTransform="uppercase" fontWeight="bold" onClick={onApprove}>
                        {item.system_id === 'SCHEDULED_CHANGE_REQUESTS'
                            ? t('tasksApprovals.drawer.buttons.viewOn')
                            : t('tasksApprovals.drawer.buttons.handleOn')}{' '}
                        {systemName}
                    </Button>
                )}
            </Box>
        </Box>
    )
}

export default Container
